import { render, staticRenderFns } from "./point-amount.vue?vue&type=template&id=91f6df00"
import script from "./point-amount.vue?vue&type=script&lang=js"
export * from "./point-amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91f6df00')) {
      api.createRecord('91f6df00', component.options)
    } else {
      api.reload('91f6df00', component.options)
    }
    module.hot.accept("./point-amount.vue?vue&type=template&id=91f6df00", function () {
      api.rerender('91f6df00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/point-amount.vue"
export default component.exports